import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const chatThread = gql`
  query CardChatThreadQuery($id: UUID!) {
    thread: getThread(id: $id) {
      ...Thread
    }
  }

  ${Fragments.thread.thread}
`;

export const getEntityAuditTrail = gql`
  query GetEntityAuditTrailQuery($input: GetEntityAuditTrail!) {
    trail: getEntityAuditTrail(input: $input) {
      entityAuditTrailEvents {
        id
        timestamp
        userId
        originUserId
        workflowTemplateId
        cardId
        entries {
          id
          componentId
          componentType
          change {
            ...AnyComponentDataChange
          }
        }
      }
      refs {
        ...EntityRefs
      }
    }
  }

  ${Fragments.entity.EntityRefs}
  ${Fragments.card.change}
`;
